module.exports = __webpack_public_path__ + "img/4.8395e740.jpg";